<template>
  <div>
    <body class="login-container">
      <!-- Page container -->
      <div class="page-container">
        <!-- Page content -->
        <div class="page-content">
          <!-- Main content -->
          <div class="content-wrapper">
            <!-- Content area -->
            <div class="content pb-20">
              <!-- Tabbed form -->
              <div class="tabbable panel login-form width-400">
                <ul class="nav nav-tabs nav-justified">
                  <li
                    style="background-image: radial-gradient(circle farthest-corner at 10% 20%,rgba(0, 107, 141, 1) 0%,rgba(0, 69, 91, 1) 90%);"
                    class="active"
                  >
                    <a href="#basic-tab1" data-toggle="tab"
                      ><h6 style="color: #fafafa">Sign in</h6></a
                    >
                  </li>
                </ul>

                <div class="tab-content panel-body">
                  <div class="tab-pane fade in active" id="basic-tab1">
                    <form @submit.prevent="login()">
                      <div class="text-center">
                        <div class="icon-object border-slate-300 text-slate-300">
                          <i class="material-icons">person</i>
                        </div>
                        <h5 class="content-group">Login to your account</h5>
                      </div>

                      <v-flex sm12 md12>
                        <v-text-field
                          append-icon="mail"
                          v-model="loginData.email"
                          label="Email"
                          :error-messages="errors.collect('email')"
                          v-validate="'required|email'"
                          data-vv-name="email"
                        ></v-text-field>
                      </v-flex>

                      <v-flex sm12 md 12>
                        <v-text-field
                          v-model="loginData.password"
                          :append-icon="e1 ? 'visibility' : 'visibility_off'"
                          :append-icon-cb="() => (e1 = !e1)"
                          :type="e1 ? 'password' : 'text'"
                          label="Password"
                          v-validate="'required|min:6'"
                          :error-messages="errors.collect('password')"
                          data-vv-name="password"
                        ></v-text-field>
                      </v-flex>

                      <v-flex sm12 md 12>
                        <v-btn
                          type="submit"
                          style="height:auto; width:100%; color: white; background-color: #36457f"
                          >Login &nbsp; <i class="material-icons">forward</i></v-btn
                        >
                      </v-flex>
                    </form>
                  </div>
                </div>
              </div>
              <!-- /tabbed form -->
            </div>
            <!-- /content area -->
          </div>
          <!-- /main content -->
        </div>
        <!-- /page content -->
      </div>
      <!-- /page container -->
    </body>

    <!-- <router-view></router-view> -->
  </div>
</template>

<script>
export default {
  props: ['changeLogin'],

  $_veeValidate: {
    validator: 'new'
  },
  data() {
    return {
      e1: true,
      loginData: {
        email: '',
        password: ''
      }
    }
  },
  methods: {
    login() {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.changeLogin(this.loginData)
        }
      })
    }
  }
}
</script>

<style>
.login-container .page-container {
  padding-top: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/staffLogin.vue